import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Removido todo redirecionamento para HashRouter
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#1B182D] text-white">
      <h1 className="text-4xl font-bold mb-4">404 - Not Found</h1>
      <p className="text-lg mb-8">The page you are looking for does not exist.</p>
      <a href="/" className="text-[#D72E16] underline">Go to Home</a>
    </div>
  );
}
